









































































































































































import _isNull from "lodash/isNull";
import _cloneDeep from "lodash/cloneDeep";
import _clone from "lodash/clone";
import { Component, Vue, Watch } from "vue-property-decorator";
import qNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import { UserCustomer } from "@/model/user";
import customerApi from "@/api/customerApi";
import Customer, { CustomerDTO } from "@/model/customer";
import QSelect2 from "@/common/qSelect2.vue";
import { compareWithKeys, formatPostalCode } from "@/common/utils";
import qInput from "@/components/common/qInput.vue";

@Component({
  name: "CustomerEdit",
  components: {
    QErrors,
    QSelect2,
    qInput,
  },
})
export default class CustomerEdit extends Vue {
  isVisible = false;
  isNew = false;
  errors = [];
  customers: Customer[] = [];
  options: any = [];

  userCustomerData = new UserCustomer();
  userCustomerDataInit = new UserCustomer();
  cloneUserCustomerData;

  public created() {
    this.fetchCustomers();
  }

  public async fetchCustomers() {
    this.customers = await customerApi.getAllCustomers();
    this.options = this.customers.map((item) => ({
      id: item.customer_code,
      text: item.customer_name,
    }));
  }

  get title() {
    return this.isNew
      ? this.$t("m_cart_account.title_create")
      : this.userCustomerData.account_supervisor_name;
  }

  public formatPostalCode() {
    return formatPostalCode(this.userCustomerData.customer.postal_code);
  }

  @Watch("userCustomerData.customer_code", { deep: true })
  changeCustomerCode() {
    let customerCurrent = new CustomerDTO();
    const chooseCustomerCode = this.userCustomerData.customer_code;
    this.customers.map((customer) => {
      if (customer.customer_code == chooseCustomerCode) {
        customerCurrent = customer;
      }
    });
    this.userCustomerData.customer = customerCurrent;
  }

  public show(userCustomer: UserCustomer = null) {
    this.errors = [];
    this.isVisible = true;
    this.isNew = _isNull(userCustomer);

    if (this.isNew) {
      this.userCustomerData = new UserCustomer();
      this.userCustomerData.account_authority = 2;
      if (this.options.length == 1) {
        this.userCustomerData.customer_code = this.options[0].id;
      }
    } else {
      this.userCustomerData = _clone(userCustomer);
      this.cloneUserCustomerData = _clone(userCustomer);
    }

    this.userCustomerDataInit = _cloneDeep(this.userCustomerData);
  }

  public save() {
    this.userCustomerData.save().then(
      (result: any) => {
        qNotify.success({
          text: result.meta.message,
        });
        this.$emit("save", {});
        this.hide();
      },
      (error) => {
        this.errors = error.meta.errors;
        qNotify.error({
          text: error.meta.message,
        });
      }
    );
  }

  public close() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.cancel_message", {
          name: this.userCustomerData.account_supervisor_name,
        })}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        confirmClass: "mb__add-color-blue",

        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.hide();
        },
      });
    } else {
      this.hide();
    }
  }

  public hide() {
    this.isVisible = false;
  }

  public remove() {
    this.$modal.showDelete({
      text: `${this.userCustomerData.login_id}${this.$t(
        "m_cart_account.delete_message"
      )}`,
      confirmClass: "mb__add-color-red",
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.userCustomerData.delete().then(
          (response: any) => {
            this.hide();
            this.$emit("save", {});
            qNotify.success({
              text: response.meta.message,
            });
          },
          (error) => {
            qNotify.error({
              text: error.message,
            });
          }
        );
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  clearError(key) {
    if (key in this.errors) {
      this.errors[key] = [];
    }
  }

  public isChanged() {
    return compareWithKeys(this.userCustomerData, this.userCustomerDataInit, [
      "customer_code",
      "account_authority",
      "account_supervisor_name",
      "mail_address",
      "login_id",
      "login_password",
    ]);
  }
}
